module.exports = __webpack_public_path__ + "media/icons/pro-8db1f03e.png";